(function () {
  'use strict';

  var PROFILE_KEY = 'zane_mtm_profile';
  var SYNCED_KEY  = 'zane_mtm_profile_synced';

  function syncToCart(profileJson) {
    if (!profileJson) return;
    if (sessionStorage.getItem(SYNCED_KEY) === profileJson) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { zane_fit_profile: profileJson } })
    }).then(function (res) {
      if (res.ok) sessionStorage.setItem(SYNCED_KEY, profileJson);
    }).catch(function () {});
  }

  // Sync any existing profile on every page load
  syncToCart(localStorage.getItem(PROFILE_KEY));

  // Intercept real-time saves in the same tab
  var _orig = localStorage.setItem.bind(localStorage);
  localStorage.setItem = function (key, value) {
    _orig(key, value);
    if (key === PROFILE_KEY) syncToCart(value);
  };

  // Cross-tab sync
  window.addEventListener('storage', function (e) {
    if (e.key === PROFILE_KEY && e.newValue) syncToCart(e.newValue);
  });

})();
